export function getFileExtension(filename: string): string {
  if (!filename) return '';
  const cleanPath = filename.split('?')[0];
  return cleanPath.substr(cleanPath.lastIndexOf('.') + 1).toLowerCase();
}

export function humanizeType(mimetype: string): string {
  switch (mimetype) {
    case 'xlsx':
    case 'xls':
    case 'csv':
    case 'docx':
    case 'doc':
    case 'rtf':
    case 'ppt':
    case 'pptx':
      return 'Document';
    case 'png':
    case 'jpg':
    case 'JPG':
    case 'jpeg':
    case 'bmp':
    case 'gif':
    case 'tiff':
      return 'Image';
    case 'mp3':
    case 'wav':
      return 'Audio';
    case 'avi':
    case 'mp4':
    case '3gpp':
    case 'webm':
    case 'flv':
      return 'Video';
    case 'txt':
      return 'Text';
    case 'pdf':
    case 'PDF':
      return 'Pdf';
    case 'zip':
    case 'rar':
    case '7z':
      return 'Archive file';
    default:
      return '';
  }
}
